import { removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import actions from '@/collections/constants';
import { updateDatasetCollectionsListState } from './state';

const destroyDatasetCollectionsList = withDraft((draft, { items }) => {
  items.forEach((collection) => {
    draft.datasetCollections.entities = draft.datasetCollections.entities.map((item) => ({
      ...item,
      results: removeItemByCode(item.results, collection),
    }));
  });
});

const updateDatasetCollectionsList = withDraft((draft, { result }) => {
  updateDatasetCollectionsListState(draft, result);
});

const saveCollectionImageSuccess = withDraft((draft, { code, imageKey }) => {
  updateDatasetCollectionsListState(draft, { code, imageKey });
});

export default {
  [actions.DESTROY_COLLECTION]: destroyDatasetCollectionsList,
  [actions.SAVE_COLLECTION_IMAGE_SUCCESS]: saveCollectionImageSuccess,
  [actions.UPDATE_COLLECTION_SUCCESS]: updateDatasetCollectionsList,
};
